import { render, staticRenderFns } from "./GeneralDHRInfo.vue?vue&type=template&id=cfcbf4c2&scoped=true&"
import script from "./GeneralDHRInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralDHRInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDHRInfo.vue?vue&type=style&index=0&id=cfcbf4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcbf4c2",
  null
  
)

export default component.exports